exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3mltOkrs2n{z-index:1;top:3pc;background-position:center;background-size:cover}._3mltOkrs2n,._3mltOkrs2n:before{position:absolute;left:0;bottom:0;right:0}._3mltOkrs2n:before{z-index:0;height:75%;content:\"\";background-image:linear-gradient(transparent,rgba(0,0,0,.4))}._3Zrp_8dV9c{position:absolute;z-index:2;top:0;right:0;left:0;bottom:0}._1UPcf2GDg2{font-size:36px;font-weight:700;z-index:1;bottom:60px;overflow:hidden;margin:0 0 15px;line-height:34px;color:#fff}._1UPcf2GDg2,._2AX8Ef6v_3{position:absolute;left:20px;right:20px;text-align:center}._2AX8Ef6v_3{bottom:30px}._2AX8Ef6v_3 .like-w{float:none;display:inline-block;vertical-align:middle;margin-left:10px}._2AX8Ef6v_3 .btn{position:relative;z-index:5}", ""]);

// exports
exports.locals = {
	"item": "_3mltOkrs2n",
	"link": "_3Zrp_8dV9c",
	"title": "_1UPcf2GDg2",
	"actions": "_2AX8Ef6v_3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/components/SpecialGoalCard/SpecialGoalCard.scss
// module id = 674
// module chunks = 5 37